import * as types from '../../constants/actionTypes';

import { API_URL, BASE_API_URL } from 'constants/apiUrl';
import Axios from 'axios';

const SET_LOGIN_SUCCESS = 'SET_LOGIN_SUCCESS';
const SET_TOKEN_USER = 'SET_TOKEN_USER';
const SET_TOKEN_SSO = 'SET_TOKEN_SSO';
const SET_LOGIN_ERROR = 'SET_LOGIN_ERROR';
const SET_PROFILE = 'SET_PROFILE';
const SET_COURSEDATA = 'SET_COURSEDATA';
const SET_MENU_SHOW = 'SET_MENU_SHOW';

export function login(username, password) {
  return dispatch => {
    dispatch(setLoginSuccess(false));
    dispatch(setLoginError(null));
    dispatch(setMenuShow([]));
    dispatch(setTokenUser(null));
    dispatch(setTokenSSO(null));

    Axios.post(
      `${BASE_API_URL}/user/principal/login`,
      {
        username: username,
        password: password,
        realm: "eksternal"
        // realm: "eksternal-dev"

      },
    )
      .then(response => {
        if (response.status === 200) {
          Axios.interceptors.request.use(config => {
            config.headers = { Authorization: `Bearer ${response.data.token}` };
            return config;
          }, error => {
            return Promise.reject(error);
          });
          dispatch(setTokenUser(response.data.token));
          // dispatch(checkRole(response.data.message));
        } else {
          dispatch(setLoginError('Gagal Login, Silahkan periksa Username atau Password Anda'));
        }
      })
      .catch(error => {
        dispatch(setLoginError('Gagal Login, Silahkan periksa Username atau Password Anda'));
      });
  };
}

export function SelectDataMenu() {
  return dispatch => {
    Axios.get(`${API_URL}/activity/app_menu`)
      .then(response => {
        dispatch(setMenuShow(response.data));
      })
  };
}

export function checkRole(token) {
  return dispatch => {
    dispatch(setProfile('', '', [], '', '', '', {}));
    Axios.get(`${API_URL}/activity/user/me`)
      .then(response => {
        let hasil = response.data;
        let role = hasil.group;
        if (role === "Student" || role === "Basic") {
          dispatch(logout());
          dispatch(setLoginError('Gagal Login, Anda Tidak Memiliki Akses'));
        } else {
          dispatch(setTokenUser(token));
        }
      });
  };
}

export function checkRoleSSO(token, tokenout) {
  return dispatch => {
    dispatch(setProfile('', '', [], '', '', '', {}));
    Axios.get(`${API_URL}/activity/user/me`)
      .then(response => {
        let hasil = response.data;
        let role = hasil.group;
        if (role === "Student" || role === "Basic") {
          dispatch(logout());
          dispatch(setLoginError('Gagal Login, Anda Tidak Memiliki Akses'));
        } else {
          dispatch(setTokenUser(token));
          dispatch(setTokenSSO(tokenout));
        }
      });
  };
}

export function getProfile() {
  return dispatch => {
    dispatch(setProfile('', '', [], '', '', '', {}));
    Axios.get(`${BASE_API_URL}/user/principal/me`)
      .then(response => {
        let hasil = response.data;
        let nip = hasil.nip;
        let nama = hasil.name;
        let role = hasil.authorities;
        let username = hasil.username;
        let email = hasil.email;
        let orgcode = hasil.organization_code;
        let department = hasil.department

        dispatch(setProfile(nip, nama, role, username, email, orgcode, department));
      });
  };
}

export function getOAuth2Profile(token, idtoken) {
  return dispatch => {
    dispatch(setLoginSuccess(false));
    dispatch(setLoginError(null));
    dispatch(setMenuShow([]));
    dispatch(setTokenUser(null));
    dispatch(setTokenSSO(null));
    dispatch(setProfile('', '', '', '', '', '', {}));

    Axios.interceptors.request.use(config => {
      config.headers = { Authorization: `Bearer ${token}` };
      return config;
    }, error => {
      return Promise.reject(error);
    });
    dispatch(setTokenUser(token));
    dispatch(setTokenSSO(idtoken));
    // dispatch(checkRoleSSO(token, tokenout));
  };
}

export function getCourse() {
  return dispatch => {
    dispatch(setCourseData('', '', ''));
    Axios.get(`${API_URL}/course`)
      .then(response => {
        let data = response.data.content;
        let responsestatus = 0;
        let pages = response.data.total_pages;
        dispatch(setCourseData(data, responsestatus, pages));
      })
      .catch(error => {
        console.log('error get course');
      });
  };
}

export function logout() {
  return dispatch => {
    Axios.post(`${BASE_API_URL}/user/principal/logout`)
      .then(response => {
        dispatch(setTokenUser(null));
        dispatch(setLoginSuccess(false));
        dispatch(setMenuShow([]));
        dispatch(setProfile('', '', [], '', '', '', {}));
      })
  }
}

export function logoutNoXhr() {
  return dispatch => {
    dispatch(setTokenUser(null));
    dispatch(setLoginSuccess(false));
    dispatch(setMenuShow([]));
    dispatch(setProfile('', '', [], '', '', '', {}));
  };
}

function setProfile(nip, nama, role, username, email, orgcode, department) {
  return {
    type: SET_PROFILE,
    nip,
    nama,
    role,
    username,
    email,
    orgcode,
    department
  };
}

function setCourseData(data, response, pages) {
  return {
    type: SET_COURSEDATA,
    data,
    response,
    pages,
  };
}

function setLoginSuccess(isLoginSuccess) {
  return {
    type: SET_LOGIN_SUCCESS,
    isLoginSuccess,
  };
}

function setTokenUser(token) {
  return {
    type: SET_TOKEN_USER,
    token,
  };
}

function setTokenSSO(tokensso) {
  return {
    type: SET_TOKEN_SSO,
    tokensso,
  };
}

function setLoginError(loginError) {
  return {
    type: SET_LOGIN_ERROR,
    loginError,
  };
}

function setMenuShow(menuShow) {
  return {
    type: SET_MENU_SHOW,
    menuShow,
  };
}

const settings = (
  state = {
    layout: '1',
    boxedLayout: false,
    fixedSidenav: false,
    fixedHeader: false,
    collapsedNav: false,
    offCanvasNav: false,
    sidenavWidth: 240,
    offCanvasMobileNav: true,
    colorOption: '34',
    theme: 'light',
    isLoginSuccess: false,
    jwt: '',
    loginError: null,
    menuShow: [],
    token: null
  },
  action
) => {
  switch (action.type) {
    case SET_LOGIN_SUCCESS:
      return Object.assign({}, state, {
        isLoginSuccess: action.isLoginSuccess,
      });
    case SET_TOKEN_USER:
      return Object.assign({}, state, {
        token: action.token,
      });
    case SET_TOKEN_SSO:
      return Object.assign({}, state, {
        tokensso: action.tokensso,
      });
    case SET_MENU_SHOW:
      return Object.assign({}, state, {
        menuShow: action.menuShow,
      });
    case SET_LOGIN_ERROR:
      return Object.assign({}, state, {
        loginError: action.loginError,
      });
    case types.CHANGE_LAYOUT:
      return {
        ...state,
        layout: action.layoutOption,
      };
    case types.TOGGLE_BOXED_LAYOUT:
      return {
        ...state,
        boxedLayout: action.isBoxedLayout,
      };
    case types.TOGGLE_FIXED_SIDENAV:
      return {
        ...state,
        fixedSidenav: action.isFixedSidenav,
      };
    case types.TOGGLE_FIXED_HEADER:
      return {
        ...state,
        fixedHeader: action.isFixedHeader,
      };
    case types.TOGGLE_COLLAPSED_NAV:
      return {
        ...state,
        collapsedNav: action.isCollapsedNav,
      };
    case types.TOGGLE_OFFCANVAS_NAV:
      return {
        ...state,
        offCanvasNav: action.isOffCanvasNav,
      };
    case types.CHANGE_SIDENAV_WIDTH:
      return {
        ...state,
        sidenavWidth: action.sidenavWidth,
      };
    case types.TOGGLE_OFFCANVAS_MOBILE_NAV:
      return {
        ...state,
        offCanvasMobileNav: action.isOffCanvasMobileNav,
      };
    case types.CHANGE_COLOR_OPTION:
      return {
        ...state,
        colorOption: action.colorOption,
      };
    default:
      return state;
  }
};

const userprofile = (
  state = {
    nip: '',
    nama: '',
    role: [],
    username: '',
    email: '',
    orgcode: '',
    department: {}
  },
  action
) => {
  switch (action.type) {
    case SET_PROFILE:
      return Object.assign({}, state, {
        nip: action.nip,
        nama: action.nama,
        role: action.role,
        username: action.username,
        email: action.email,
        orgcode: action.orgcode,
        department: action.department
      });
    default:
      return state;
  }
};

const coursedata = (
  state = {
    data: [],
    response: '',
    pages: '',
  },
  action
) => {
  switch (action.type) {
    case SET_COURSEDATA:
      return Object.assign({}, state, {
        data: action.data,
        response: action.response,
        pages: action.pages,
      });
    default:
      return state;
  }
};

export { settings, userprofile, coursedata };
